import { StatusMessageContent } from './components/StatusMessageContent';

export const StatusMessage = StatusMessageContent;
export default StatusMessage;

export * from './components';
export * from './interfaces';
